import { render, staticRenderFns } from "./carindetail.vue?vue&type=template&id=1f963b76&scoped=true&"
import script from "./carindetail.vue?vue&type=script&lang=js&"
export * from "./carindetail.vue?vue&type=script&lang=js&"
import style0 from "./carindetail.vue?vue&type=style&index=0&id=1f963b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f963b76",
  null
  
)

export default component.exports